import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { ComplexValue } from 'ui';

interface SelectedGroupTextValue {
  selectedGroup?: ComplexValue<number>;
  translation: any;
}

export const selectedGroupText = (value: SelectedGroupTextValue) => {
  if (!value) {
    return;
  }

  const { selectedGroup, translation } = value;
  return (selectedGroup && isDefinedIncludingZero(selectedGroup.value))
    ? replaceTemplateString(
      translation.add_units_group_text,
      selectedGroup.description && selectedGroup.description.split(' - ').pop()
    ) : translation.unit;
};
